// Catalogus van zeedier-ontwerpen voor de Aquarium-designer.
// De tekeningen zijn met de picto-generatie van Weektaak.com gemaakt en staan
// als statische assets in public/aquarium/ (kleurversie = voorbeeld/thumbnail,
// lijnversie = kleurplaat die de leerling invult).
//
// rig = zwemgedrag op het digibord (zie digibord_dashboard/aquarium/rigs.ts).

export interface CreatureDesign {
  key: string        // bestandssleutel + template_key
  label: string
  rig: string        // animal_type dat naar het digibord gaat
  group: string
}

export const DESIGN_GROUPS: string[] = [
  'Vissen',
  'Inktvissen & kwal',
  'Schaaldieren',
  'Klein grut',
]

export const DESIGNS: CreatureDesign[] = [
  { key: 'goudvis',    label: 'Goudvis',     rig: 'fish',      group: 'Vissen' },
  { key: 'clownvis',   label: 'Clownvis',    rig: 'fish',      group: 'Vissen' },
  { key: 'vis',        label: 'Vis',         rig: 'fish',      group: 'Vissen' },
  { key: 'kogelvis',   label: 'Kogelvis',    rig: 'fish',      group: 'Vissen' },
  { key: 'zwaardvis',  label: 'Zwaardvis',   rig: 'fish',      group: 'Vissen' },
  { key: 'octopus',    label: 'Octopus',     rig: 'octopus',   group: 'Inktvissen & kwal' },
  { key: 'inktvis',    label: 'Inktvis',     rig: 'octopus',   group: 'Inktvissen & kwal' },
  { key: 'kwal',       label: 'Kwal',        rig: 'jellyfish', group: 'Inktvissen & kwal' },
  { key: 'krab',       label: 'Krab',        rig: 'crab',      group: 'Schaaldieren' },
  { key: 'kreeft',     label: 'Kreeft',      rig: 'crab',      group: 'Schaaldieren' },
  { key: 'garnaal',    label: 'Garnaal',     rig: 'crab',      group: 'Schaaldieren' },
  { key: 'zeester',    label: 'Zeester',     rig: 'drift',     group: 'Schaaldieren' },
  { key: 'schildpad',  label: 'Schildpadje', rig: 'turtle',    group: 'Klein grut' },
  { key: 'zeepaardje', label: 'Zeepaardje',  rig: 'seahorse',  group: 'Klein grut' },
  // Nieuwe soort altijd achteraan (species_index in de ArUco-markers).
  { key: 'rog',        label: 'Rog',         rig: 'ray',       group: 'Vissen' },
  { key: 'doktersvis', label: 'Doktersvis',  rig: 'fish',      group: 'Vissen' },
  { key: 'witpuntrifhaai', label: 'Witpuntrifhaai', rig: 'fish', group: 'Vissen' },
  { key: 'discusvis', label: 'Discusvis',    rig: 'fish',      group: 'Vissen' },
  { key: 'engelvis',  label: 'Engelvis',     rig: 'fish',      group: 'Vissen' },
  { key: 'dolfijn',   label: 'Dolfijn',      rig: 'fish',      group: 'Vissen' },
]

const LABEL_BY_KEY = new Map(DESIGNS.map((d) => [d.key, d.label]))

// Nederlandse soortnaam bij een template_key (bv. 'krab' -> 'Krab'). Geeft
// undefined bij een onbekende of ontbrekende key.
export function speciesLabel(key: string | null | undefined): string | undefined {
  return key ? LABEL_BY_KEY.get(key) : undefined
}

// Cache-buster voor de aquarium-PNG's. De bestanden muteren (we genereren ze
// opnieuw) terwijl de URL gelijk blijft, en de public file server stuurt een
// lange Cache-Control (max-age 2 dagen in dev). Zonder buster blijven browsers
// op de oude tekening hangen. Verhoog dit getal telkens als je een bestaand
// dier opnieuw genereert (rails aquarium:creature/aquarium:assets).
export const ASSET_VERSION = 4

export function colorUrl(key: string): string {
  return `/aquarium/${key}-color.png?v=${ASSET_VERSION}`
}

export function lineUrl(key: string): string {
  return `/aquarium/${key}-line.png?v=${ASSET_VERSION}`
}
